import { FiMessageCircle } from "react-icons/fi";
import styled, { css } from "styled-components";

import FlexBox from "./FlexBox";
import { ACCENT_100, ACCENT_800, PRIMARY_800 } from "./colors";

const Container = styled(FlexBox)`
  position: relative;
  flex-shrink: 0;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  transition: opacity 300ms ease-in-out;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  ${({ hideIcon }) =>
    hideIcon &&
    css`
      opacity: 0;
      cursor: default;
    `}

  ${({ disabled, hoverBgColor }) =>
    !disabled &&
    hoverBgColor &&
    css`
      border-radius: 50%;
      :hover {
        background-color: ${hoverBgColor};
      }
    `}
`;

const Count = styled(FlexBox)`
  top: 0;
  right: 0;
  position: absolute;
  width: ${({ countSize }) => countSize};
  height: ${({ countSize }) => countSize};
  background-color: ${PRIMARY_800};
  color: ${ACCENT_100};
  border-radius: 50%;
  font-size: 0.625rem;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border: 2px solid ${ACCENT_100};
`;

const IconWithCount = ({
  onClick,
  className,
  Icon = FiMessageCircle,
  size = "2rem",
  iconSize = "1.75rem",
  count = null,
  countSize = "1rem",
  hideIcon = false,
  disabled = false,
  hoverBgColor = null,
}) => {
  const showCount = !disabled && !!count;
  return (
    <Container
      size={size}
      className={className}
      onClick={disabled || hideIcon ? undefined : onClick}
      disabled={disabled}
      hideIcon={hideIcon}
      hoverBgColor={hoverBgColor}
    >
      {showCount && <Count countSize={countSize}>{count}</Count>}
      <Icon
        size={iconSize}
        fill={showCount ? PRIMARY_800 : ACCENT_100}
        stroke={showCount ? PRIMARY_800 : ACCENT_800}
      />
    </Container>
  );
};

export default IconWithCount;
